<mat-card style="min-height: 500px">
    <mat-card-content>
        <div class="max-width">
            <div class="form-group row mb-3">
                <div class="col-md-3">
                    <app-select-academic-year-only
                        (academicYearChanged)="onChangeAcademicYear($event)">
                    </app-select-academic-year-only>
                </div>
                <div class="col-md-3">
                    <app-select-school-level-relation-v2
                        [academic_year]="this.paramForm.get('academic_year')?.value"
                        (schoolLevelRelationChanged)="onChangeSchoolLevel($event)"
                        [isDisabled]="!this.paramForm.get('academic_year')?.value">
                    </app-select-school-level-relation-v2>
                </div>
                <div class="col-md-3">
                    <app-select-school-program
                        [school_location_id]="this.paramForm.get('school_location_id')?.value"
                        [isDisabled]="!this.paramForm.get('school_location_id')?.value"
                        (schoolProgramChanged)="onChangeSchoolProgram($event)">
                    </app-select-school-program>
                </div>
               <div class="col-md-3">
                   <app-select-school-program-category
                        [school_program_id]="this.paramForm.get('school_program_id')?.value"
                        [isDisabled]="!this.paramForm.get('school_program_id')?.value"
                        [all]="true"
                        (schoolProgramCategoryChanged)="onChangeSchoolProgramCategory($event)">
                   </app-select-school-program-category>
               </div>
            </div>
            <div class="col-4 mb-3" *ngIf="!loading">
                <input type="text" [(ngModel)]="searchParam" placeholder="{{ 'SEARCH' | translate }}" class="form-control" (keydown.enter)="getActivityData()">
            </div>
            <div *ngIf="loading" class="d-flex justify-content-center align-items-center" style="margin-top:70px">
                <mat-spinner></mat-spinner>
            </div>
            <div>
                <app-status-no-data [show]="data.length === 0 && !loading"></app-status-no-data>
            </div>
            <div class="table-responsive">
                <table mat-table *ngIf="data.length > 0 && !loading"
                       [dataSource]="data" multiTemplateDataRows
                       >
                    <ng-container matColumnDef="school_program_name">
                        <th mat-header-cell *matHeaderCellDef (click)="onSort('school_program_name')" class="cursor-pointer"> {{ 'SCHOOL_PROGRAM' | translate }} </th>
                        <td mat-cell *matCellDef="let element" class="example-element-position">
                            {{element.school_program_name || '-'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="school_program_category_name">
                        <th mat-header-cell *matHeaderCellDef (click)="onSort('school_program_category_name')" class="cursor-pointer"> {{ 'CATEGORY_NAME' | translate }} </th>
                        <td mat-cell *matCellDef="let element" class="example-element-position">
                            {{element.category_name || '-'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="activity_name">
                        <th mat-header-cell *matHeaderCellDef (click)="onSort('activity_name')" class="cursor-pointer"> {{ 'ACTIVITY_NAME' | translate }} </th>
                        <td mat-cell *matCellDef="let element" class="example-element-position">
                            {{element.activity_name || '-'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="action" *ngIf="auth.permissions['SCHOOL_PROGRAM_ACTIVITY_APPROVER_APPROVE'] || auth.permissions['SCHOOL_PROGRAM_ACTIVITY_APPROVER_REJECT']">
                        <th mat-header-cell *matHeaderCellDef style="text-align: center"> {{ 'ACTIONS' | translate }} </th>
                        <td mat-cell *matCellDef="let element" class="example-element-weight">
                            <div class="d-flex justify-content-center gap-1">
                                <button
                                    class="action-icon-btn action-icon-reject"
                                    *ngIf="auth.permissions['SCHOOL_PROGRAM_ACTIVITY_APPROVER_REJECT']"
                                    (click)="saveApprove(element, false)"
                                    [title]="'REJECT' | translate">
                                    <div>
                                        <i-feather name="x" class="feather-base"></i-feather>
                                    </div>
                                </button>
                                <button
                                    class="action-icon-btn action-icon-approve"
                                    *ngIf="auth.permissions['SCHOOL_PROGRAM_ACTIVITY_APPROVER_APPROVE']"
                                    (click)="saveApprove(element, true)"
                                    [title]="'APPROVE' | translate">
                                    <div>
                                        <i-feather name="check" class="feather-base"></i-feather>
                                    </div>
                                </button>
                            </div>

                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
                    <tr mat-row *matRowDef="let element; let i = index; columns: columnsToDisplay;" class="example-element-row">
                    </tr>
                </table>
            </div>
        </div>
    </mat-card-content>
</mat-card>
